export const getValueOrUndefined = <T>(value: T, condition?: boolean) => {
  if (condition !== undefined) {
    if (condition) {
      return value;
    }
    return undefined;
  }
  if (value) {
    return value;
  }
  return undefined;
};

export const isValueDefined = (value: any, condition?: boolean): boolean => {
  if (condition !== undefined) {
    if (condition) {
      return true;
    }
    return false;
  }
  if (value) {
    return true;
  }
  return false;
};

export const isObjectEmpty = (object: any) =>
  object === undefined || Object.keys(object).length === 0;
